export default function scrollDetection() {
    const scroll = window.scrollY;
    let header = document.querySelector('.header--scrolled');
    window.innerWidth > 1200 ? header = document.querySelector('.header--scrolled') : header = document.querySelector('.header');
    if (!header) return;

    if(window.innerWidth > 1200) {
        scroll > 0 ? header.classList.remove('hidden') : header.classList.add('hidden');
    } else {
        scroll > 0 ? header.classList.add('header--scrolled') : header.classList.remove('header--scrolled');
    }
}

let ticking = false;
window.addEventListener('scroll', () => {
    if (!ticking) {
        requestAnimationFrame(() => {
            scrollDetection();
            ticking = false;
        });
        ticking = true;
    }
});
